'use client';

import { FC } from 'react';
import { TheoryActivitySelectionDialog } from './TheoryActivitySelectionDialog';
import { useDialogStore } from '@/stores/dialogStore';
import { TheoryActivityRowType } from '@/components/tables/TheoryActivityGridCore';
import { TheoryActivityDto } from '@/api/ApiClient';

/**
 * Wrapper component that connects TheoryActivitySelectionDialog to the dialog store.
 * This is the global instance that should be rendered once in the app.
 */
export const TheoryActivitySelectionDialogWrapper: FC = () => {
  const { theoryActivitySelectionDialog, closeTheoryActivitySelectionDialog } = useDialogStore();

  const handleActivitiesSelect = (activities: TheoryActivityRowType[]) => {
    // Convert TheoryActivityRowType[] to TheoryActivityDto[]
    const activityDtos: TheoryActivityDto[] = activities.map((activity) => ({
      id: activity.id,
      description: activity.description,
      date: activity.date ? new Date(activity.date) : undefined,
      simulationTechnique: activity.technique,
      software: activity.software,
      version: activity.version,
      projectLabel: activity.projectLabel,
      dataPackageLabel: activity.dataPackageLabel,
      status: activity.status,
      lastChangedDate: activity.lastChangedDate ? new Date(activity.lastChangedDate) : undefined,
      lastChangedBy: activity.lastChangedBy,
    }));

    closeTheoryActivitySelectionDialog(activityDtos);
  };

  const handleClose = () => {
    closeTheoryActivitySelectionDialog();
  };

  return (
    <TheoryActivitySelectionDialog
      open={theoryActivitySelectionDialog.isOpen}
      title={theoryActivitySelectionDialog.title || 'Select Theory Activities'}
      allowMultiple={true}
      onActivitiesSelect={handleActivitiesSelect}
      onClose={handleClose}
    />
  );
};
